/* eslint-disable id-length */
/* eslint-disable max-lines */
import {createStore, action} from "easy-peasy";
import {getPath, getAnswers, getCurrentQuestionId, getQuestionHistory, getAnimationId, getAnimationLoop} from './restoreStateFromQuery';

const getInitialPath = () => getPath();

const getInitialQuestionId = () => getCurrentQuestionId();

const getInitialQuestionHistory = () => getQuestionHistory();

const getInitialAnimationId = () => getAnimationId();

const getInitialLoopAnimationId = () => getAnimationLoop();

const getInitialLtm = () => getAnswers();

const PATHS = [
    `/intro`,
    `/q1`,
    `/q2`,
    `/q3`,
    `/q4`,
    `/results`
];

export default createStore({
    path : {
        current : getInitialPath(),
        goto    : action((state, payload) => {
            if (PATHS.includes(payload)) {
                state.current = payload;
            } else {
                throw new Error(`Chris fucked up`);
            }
        })
    },
    question : {
        currentId : getInitialQuestionId(),
        history   : getInitialQuestionHistory(),
        goBack    : action((state, payload) => {
            const lastId = state.history.pop();
            if (lastId) {
                state.currentId = lastId;
            }
        }),
        setCurrentId : action((state, payload) => {
            if (state.currentId) {
                state.history.push(state.currentId);
            }
            state.currentId = payload;
        })
    },
    animation : {
        history   : [],
        currentId : getInitialAnimationId(),
        current   : {
            path     : getInitialAnimationId(),
            autoplay : true,
            loop     : getInitialLoopAnimationId()
        },
        setCurrentId : action((state, payload) => {
            state.currentId = payload;
        }),
        goBack : action((state, payload) => {
            let index = 0;
            if (/loop/.test(state.currentId)) {
                index = state.history.length - 2;
            } else {
                index = state.history.length - 1;
            }
            let goBackTo = state.history[index];

            if (!goBackTo) {
                return;
            }

            state.current = {
                path          : goBackTo,
                autoplay      : false,
                loop          : false,
                goToLastFrame : true
            };
        }),
        setCurrent : action((state, payload) => {
            state.current = payload;
        }),
        initialize : action(state => {
            state.initialized = true;
        })
    },
    answers : {
        current : getInitialLtm(),
        update  : action((state, payload) => {
            state.current = payload;
        }),
        add : action((state, payload) => {
            state.current.push(payload);
        })
    },
    content : {
        all    : [],
        update : action((state, payload) => {
            state.all = payload;
        })
    },
    resultsCopy : {
        heroTitle                : ``,
        heroDescription          : {},
        contentSeriesIntro       : ``,
        contentSeriesTitle       : ``,
        contentSeriesHeadline    : ``,
        contentSeriesSubheadline : ``,
        contentSeriesBody        : ``,
        contentSeriesVideo       : ``,
        becauseYouSaid           : ``,
        didYouKnow               : ``,
        didYouKnowSource         : ``,
        guardianHeadline         : ``,
        guardianCTA              : ``,
        guardianCTAURL           : ``,
        shareResultsHeadline     : ``,
        shareResultsCTA          : ``,
        update                   : action((state, payload) => {
            state.heroTitle                 = payload.heroTitle;
            state.heroDescription           = payload.heroDescription;
            state.contentSeriesIntro        = payload.contentSeriesIntro;
            state.contentSeriesTitle        = payload.contentSeriesTitle;
            state.contentSeriesHeadline     = payload.contentSeriesHeadline;
            state.contentSeriesSubheadline  = payload.subHeadline;
            state.contentSeriesBody         = payload.contentSeriesBody;
            state.contentSeriesVideo        = payload.contentSeriesVideo;
            state.videoThumbnailDescription = payload.videoThumbnailDescription;
            state.videoThumbnail            = `https:${payload.contentSeriesVideoThumbnail.fields.file.url}`;
            state.becauseYouSaid            = payload.becauseYouSaid;
            state.didYouKnow                = payload.didYouKnow;
            state.didYouKnowSource          = payload.didYouKnowSource;
            state.guardianHeadline          = payload.guardianHeadline;
            state.guardianCTA               = payload.guardianCta;
            state.guardianCTAURL            = payload.guardianCtaurl;
            state.shareResultsHeadline      = payload.shareResultsHeadline;
            state.shareResultsCTA           = payload.shareResultsCta;
        })
    },
    results : {
        ltm             : ``,
        hero            : {},
        subhero         : [],
        omeleteVideo    : {},
        preparedContent : [],
        update          : action((state, payload) => {
            state.ltm             = payload.ltm;
            state.hero            = payload.hero;
            state.subhero         = payload.subhero;
            state.omeleteVideo    = payload.omeleteVideo;
            state.preparedContent = payload.preparedContent;
        })
    },
    aboutModal : {
        current      : true,
        turnOffModal : action((state, payload) => {
            state.current = false;
        })
    }
});

/*
export default {
    path             : `/`, // what page we're on [/intro, /quiz, results]
    currentQuestion  : {},
    currentAnimation : {
        data          : {},
        loopAnim      : {},
        nextAnimation : 5
    },
    answers : {
        "question-1" : `family`,
        "question-2" : `prepared`,
        "question-3" : `getting started`,
        "question-4" : [`generic`]
    },

};
*/
